<script lang="ts">
  import type { PwNextSocialProofProps } from './types';
  import SocialProofSlides from './components/SocialProofSlides.svelte';
  import ScrollExpandHelper from './helpers/ScrollExpandHelper.svelte';

  export let entryId: PwNextSocialProofProps['entryId'];
  export let slides: PwNextSocialProofProps['slides'];
  export let type: PwNextSocialProofProps['type'];
  export let cta: PwNextSocialProofProps['cta'];
  export let noise: PwNextSocialProofProps['noise'];
  export let fallbackBgColor: PwNextSocialProofProps['fallbackBgColor'];
  export let isBalanced: PwNextSocialProofProps['isBalanced'];
</script>

{#if type === 'card' || type === 'hero'}
  <ScrollExpandHelper
    expandingElementSelector={`.PwNextSocialProof-${entryId}-box-properties .slideBackground-container`}
    useOnMobile={type === 'card'}
  />
{/if}
<div
  class="PwNextSocialProof PwNextSocialProof-{entryId} PwNextSocialProof-{entryId}-box-properties"
  data-entry-id={entryId}
>
  <div class="PwNextSocialProof-GridContainer PwNextSocialProof-GridContainer--{type}">
    <SocialProofSlides {slides} {cta} {type} {noise} {fallbackBgColor} {isBalanced} />
  </div>
</div>

<style lang="scss">
  @use '@squareup/public-web-design-system/dist/tokens/generated-tokens/scss/_media_queries' as mediaQueries;
  @use '@squareup/public-web-design-system/dist/styles/xms-fe/helpers/layout' as layout;

  @layer custom-components {
    .PwNextSocialProof {
      @include layout.media-clipped-at-extra-large();
      color: var(--color-gray-99);
      position: relative;
      &-GridContainer {
        &--hero {
          max-width: 100%;
          margin: auto;

          @include mediaQueries.at('medium') {
            max-width: var(--container-width-current);
          }
        }

        &--card {
          margin: auto;
          position: relative;
        }

        &--base {
          max-width: var(--container-width-current);
          margin: auto;
        }
      }
    }
  }
</style>
